// Queries
import getPaymentIntent from "./GetPaymentIntent.gql";
import savedPaymentInfo from "./SavedPaymentInfoQuery.gql";

export const Query = {
    savedPaymentInfo,
    getPaymentIntent,
};
